import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import type { EventDetails } from 'sections/Events/components/EventDetails/EventDetails.types';
import styles from 'sections/Events/components/EventDetails/EventDetails.module.scss';

const cn = classNames.bind(styles);

interface EventDetailsProps {
  eventDetailsData: EventDetails[];
};

const EventDetails: FC<EventDetailsProps> = ({ eventDetailsData }): ReactElement => {
  return (
    <div className={cn('event-details')}>
      <div>
        {eventDetailsData.map((item: EventDetails) => {
          if (item.img && item.link) {
            return (
              <div key={item.id} className={cn('event-details__item')}>
                <img src={item.img} alt="icon" className={cn('event-details__image')}/>
                <p className={cn('event-details__text')}>
                  <a
                    className={cn('event-details__link')}
                    href={item.link}
                    target="_blank"
                    style={{ marginLeft: '0' }}
                  >
                    {item.text}
                  </a>
                </p>
              </div>
            );
          } else if (item.img) {
            return (
              <div key={item.id} className={cn('event-details__item')}>
                <img src={item.img} alt="icon" className={cn('event-details__image')} />
                <p className={cn('event-details__text')}>{item.text}</p>
              </div>
            );
          } else {
            return (
              <div key={item.id} className={cn('event-details__item')}>
                <a href={item.link} target="_blank" className={cn('event-details__link')}>
                  {item.text}
                </a>
              </div>
            );
          }
        })}
      </div>
      <div className={cn('event-details__logo-box')}>
        <img src="/images/main/events/intro/3.svg" alt="DP World" className={cn('event-details__logo')}/>
      </div>
    </div>
  );
};

export { EventDetails };